import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useLoader } from "@/hooks/LoaderProvider";
import Avatar from "@/components/common/Avatar";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";

const DonationCard = ({
  id,
  name,
  amount,
  date,
  time,
  imgUrl,
  status = "Approved",
  paymentMethod = "Paystack",
}) => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const handleCardClick = (e) => {
    if (e.target.closest("button")) return;
    showLoader();
    setTimeout(() => {
      hideLoader();
      navigate(`/dashboard/financial/donation/${id}`);
    }, 2000);
  };

  return (
    <div
      className="flex items-center justify-between p-4 mb-2 bg-white rounded-lg shadow-sm cursor-pointer hover:border-primary"
      onClick={handleCardClick}>
      {/* Left section with avatar and details */}
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <Avatar src={imgUrl} alt={name} size={48} />

        {/* Name, amount and payment method */}
        <div className="flex flex-col min-w-0">
          <h3 className="font-bold truncate text-regular">{name}</h3>
          <p className="font-bold truncate text-small">₦{amount}</p>
          <span className="font-medium text-gray-500 truncate text-small">
            {paymentMethod}
          </span>
        </div>
      </div>

      {/* Right section with date, status and options */}
      <div className="flex items-center gap-4">
        {/* Date and time */}
        <div className="text-right">
          <p className="text-xs text-gray-600">
            {date} {time}
          </p>

          {/* Status indicator */}
          <div className="flex items-center justify-end gap-1 mt-1">
            <div
              className={`w-2 h-2 rounded-full ${
                status === "Approved"
                  ? "bg-primary"
                  : status === "Pending"
                  ? "bg-warning"
                  : "bg-red-500"
              }`}></div>
            <span
              className={`text-small font-bold ${
                status === "Approved"
                  ? "text-primary"
                  : status === "Pending"
                  ? "text-warning"
                  : "text-red-500"
              }`}>
              {status}
            </span>
          </div>
        </div>

        {/* More options menu */}
        <div className="ml-2">
          <CustomMoreOptions
            variant="filled"
            onClick={(e) => e.stopPropagation()}
            color="black"
            orientation="vertical"
            size="small"
          />
        </div>
      </div>
    </div>
  );
};

DonationCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  amount: PropTypes.string,
  date: PropTypes.string,
  time: PropTypes.string,
  imgUrl: PropTypes.string,
  status: PropTypes.oneOf(["Approved", "Pending", "Rejected"]),
  paymentMethod: PropTypes.string,
};

export default DonationCard;
